import { useContext, useMemo } from 'react';
import { CheckoutContext } from '@/context/CheckoutContext';
import { Select } from '../Common/Select';
import { PaymentMethodEnum, type ExcludeOtherPaymentMethod } from '@/types/common';
import { ButtonType } from '@/types/components';
import { Button } from '../Common/Button';
import { getOtherPaymentMethods } from '@/utils/paymentMethods';
import { PaymentMethodRow } from '../PaymentMethodRow/PaymentMethodRow';
import { cn } from '@/utils/cn';
export const PaymentMethodList = () => {
  const {
    paymentMethodsAvailable,
    actions: { updateOtherMethodSelected, setPaymentMethodSelected },
    otherMethodSelected,
    drawer: { closeDrawer },
  } = useContext(CheckoutContext);
  const availablePaymentMethods = useMemo(
    () => getOtherPaymentMethods(paymentMethodsAvailable),
    [paymentMethodsAvailable]
  );

  const handleSelectPaymentMethod = (paymentMethod: ExcludeOtherPaymentMethod) => {
    updateOtherMethodSelected(paymentMethod);
    setPaymentMethodSelected(paymentMethod);
    closeDrawer();
  };

  const handleCancel = () => {
    closeDrawer();
  };
  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col gap-4 max-h-60 overflow-y-auto">
        <div className="text-base text-card-foreground font-bold">Select payment method</div>
        {availablePaymentMethods.map((pm) => (
          <Select
            key={pm.paymentMethodName}
            id={pm.paymentMethodName}
            isSelected={otherMethodSelected === pm.paymentMethodName}
            onSelect={() => {
              handleSelectPaymentMethod(pm.paymentMethodName as ExcludeOtherPaymentMethod);
            }}
            className={cn(otherMethodSelected === pm.paymentMethodName ? 'border-selected-border' : '')}
          >
            <PaymentMethodRow paymentMethod={pm.paymentMethodName as PaymentMethodEnum} />
          </Select>
        ))}
      </div>
      <div className="flex flex-col gap-2 mt-2 w-full">
        <Button type={ButtonType.LIGHT} onClick={handleCancel}>
          Cancel
        </Button>
      </div>
    </div>
  );
};
